/**
 * image-upload
 */

import Component from "../../js/lib/component";

const classList = {
  root: ".js-image-upload",
  cover: ".js-image-upload-cover",
  image: ".js-image-upload-image",
  input: ".js-image-upload-input"
};

export default class ImageUpload extends Component {
  init() {}
  events() {
    this.$.input.on("change", ({ target }) => {
      const file = target.files[0];
      const blob = file && URL.createObjectURL ? URL.createObjectURL(file) : "";

      this.createPreview(blob);
    });
  }
  createPreview(blob) {
    if (!blob) return;
    if (this.$.image.length) {
      this.$.image.attr("src", blob);
    } else {
      this.$.image = $(`<img class="image-upload__image" src="${blob}">`);
      this.$.cover.append(this.$.image);
    }
  }
  validateImage(image) {
    // check the type
    var validTypes = ["image/jpeg", "image/png", "image/gif"];
    if (validTypes.indexOf(image.type) === -1) {
      alert("Invalid File Type");
      return false;
    }

    // check the size
    var maxSizeInBytes = 10e6; // 10MB
    if (image.size > maxSizeInBytes) {
      alert("File too large");
      return false;
    }

    return true;
  }
}

Component.mount(ImageUpload, {
  name: "ImageUpload",
  classList,
  state: {}
});
